/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module AnalyticsModule
 */

/**
 * @fileoverview Contains Ajs dependency tokens for factories & collection.
 *
 * @author Ratan Kumar
 */

/**
 * Dependency token for Analytics ProfileMessage Item.
 */
export const ANALYTICS_PROFILE_ITEM_TOKEN = 'AnalyticsProfileItem';

/**
 * Dependency token for Analytics Profile Collection.
 */
export const ANALYTICS_PROFILE_COLLECTION_TOKEN = 'AnalyticsProfileCollection';

/**
 * Dependency token for SensitiveLogProfileConfigItem.
 */
export const SENSITIVE_LOG_PROFILE_CONFIG_ITEM_TOKEN = 'SensitiveLogProfileConfigItem';

/**
 * Dependency token for SensitiveFieldRuleConfigItem.
 */
export const SENSITIVE_FIELD_RULE_CONFIG_ITEM_TOKEN = 'SensitiveFieldRuleConfigItem';

/**
 * Dependency token for ClientLogStreamingConfigConfigItem.
 */
export const CLIENT_LOG_STREAMING_CONFIG_CONFIG_ITEM_TOKEN = 'ClientLogStreamingConfigConfigItem';
